import { waitForRedirection } from '../../../services/waitForRedirection';

export async function adminRoutesLoader() {
  await waitForRedirection();
}
